import React, { useEffect, useState } from 'react';
import { Container, Grid, Typography, Box } from '@mui/material';
import { motion } from 'framer-motion';
import getStyles from './styles';

const OurProjectsLogo = () => {
  const styles = getStyles();
  const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 });
  // const [scrollY, setScrollY] = useState(0);
  const [hoveredIndex, setHoveredIndex] = useState(null);

  useEffect(() => {
    const handleMouseMove = (e) => {
      setMousePosition({
        x: (e.clientX / window.innerWidth - 0.5) * 2,
        y: (e.clientY / window.innerHeight - 0.5) * 2
      });
    };

    const handleScroll = () => {
      // setScrollY(window.scrollY);
    };

    window.addEventListener('mousemove', handleMouseMove);
    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('mousemove', handleMouseMove);
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const clients = [
    {
      name: 'StartupTN',
      category: 'Technology',
      icon: '/images/startuptn-blue.png',
      gradient:
        'linear-gradient(90deg, rgba(0, 9, 36, 1) 0%, rgba(11, 64, 170, 1) 100%)',
      color: '#3b82f6'
    },
    {
      name: 'Government of Tamilnadu',
      category: 'Finance',
      icon: '/images/Tamil_Nadu_emb.png',
      gradient:
        'linear-gradient(90deg, rgba(0, 9, 36, 1) 0%, rgba(11, 64, 170, 1) 100%)',
      color: '#8b5cf6'
    },
    {
      name: 'PAARR ever',
      category: 'Media',
      icon: '/images/paar-logo.jpg',
      gradient: '',
      color: '#a855f7'
    },
    {
      name: 'Kaleesuwari',
      category: 'Sports',
      icon: '/images/ksw_logo.png',
      gradient: '#fff',
      color: '#dc2626'
    },
    {
      name: 'Karkai',
      category: 'Healthcare',
      icon: '/images/karkai.jpg',
      gradient:
        'linear-gradient(90deg, rgba(0, 9, 36, 1) 0%, rgba(11, 64, 170, 1) 100%)',
      color: '#ef4444'
    },
    {
      name: 'Seyon',
      category: 'Education',
      icon: '/images/SEYON-DI-LOGO.png',
      gradient:
        'linear-gradient(90deg, rgba(0, 9, 36, 1) 0%, rgba(11, 64, 170, 1) 100%)',
      color: '#6366f1'
    },
    {
      name: 'Link-K-TPA',
      category: 'Retail',
      icon: '/images/Link-K-Logo.png',
      gradient: '#fff',
      color: '#f97316'
    }
  ];

  return (
    <Box component="section" sx={styles.section} id="clients">
      <Box sx={styles.backgroundContainer}>
        <Box sx={styles.gradientBase} />
        {/* <motion.div
          style={{
            ...styles.geometricPattern1,
            x: mousePosition.x * 40,
            y: mousePosition.y * 40 - scrollY * 0.2,
            rotate: scrollY * 0.1
          }}
        />
        <motion.div
          style={{
            ...styles.geometricPattern2,
            x: mousePosition.x * -30,
            y: mousePosition.y * -30 - scrollY * 0.15,
            rotate: -scrollY * 0.1
          }}
        />
        <motion.div
          style={{
            ...styles.floatingOrb1,
            x: mousePosition.x * 50,
            y: mousePosition.y * 50 - scrollY * 0.3
          }}
        />
        <motion.div
          style={{
            ...styles.floatingOrb2,
            x: mousePosition.x * -40,
            y: mousePosition.y * -40 - scrollY * 0.25
          }}
        /> */}
        <Box sx={styles.gridPattern} />
        <motion.div
          style={{
            ...styles.spotlight1,
            x: mousePosition.x * 60,
            y: mousePosition.y * 60
          }}
        />
        <motion.div
          style={{
            ...styles.spotlight2,
            x: mousePosition.x * -50,
            y: mousePosition.y * -50
          }}
        />
      </Box>
      <Container maxWidth="xl" sx={styles.container}>
        {/* Header */}
        <Box sx={styles.header}>
          <Box sx={styles.headerBadge}>
            <span style={styles.badgeIcon}>⭐</span>
            <Typography sx={styles.badgeText}>Our Trusted Partners</Typography>
          </Box>
          <Typography variant="h2" sx={styles.title}>
            Trusted by Industry{' '}
            <span style={styles.titleGradient}>Pioneers</span>
          </Typography>

          <Typography sx={styles.subtitle}>
            From startups to Fortune 500 companies, we empower organizations to
            achieve their digital transformation goals
          </Typography>
        </Box>
        <Grid container spacing={3} justifyContent="center">
          {clients.map((client, index) => (
            <Grid
              item
              xs={12}
              sm={6}
              md={4}
              lg={3}
              key={client.name}
              sx={styles.gridItem}
            >
              <motion.div
                initial={{ opacity: 0, y: 40 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: index * 0.1 }}
                onMouseEnter={() => setHoveredIndex(index)}
                onMouseLeave={() => setHoveredIndex(null)}
              >
                <Box sx={styles.clientCard}>
                  <Box
                    sx={{
                      ...styles.cardGlow,
                      // background:
                      //   hoveredIndex === index
                      //     ? client.gradient
                      //     : 'transparent',
                      opacity: hoveredIndex === index ? 0.6 : 0
                    }}
                  />
                  {/* <Box
                    sx={{
                      ...styles.animatedBorder,
                      borderColor:
                        hoveredIndex === index
                          ? client.color
                          : 'rgba(255, 255, 255, 0.1)'
                    }}
                  /> */}
                  <Box sx={styles.cardContent}>
                    <motion.div
                      style={{
                        ...styles.iconContainer
                        // background: client.gradient
                      }}
                      // animate={{
                      //   scale: hoveredIndex === index ? 1.1 : 1,
                      //   rotate: hoveredIndex === index ? 5 : 0
                      // }}
                      transition={{ duration: 0.4 }}
                    >
                      <Box sx={styles.iconInner}>
                        <img
                          src={client.icon}
                          alt="Client Logo"
                          style={styles.icon}
                        />
                      </Box>
                      {/* <Box
                        sx={{
                          // ...styles.iconRing,
                          // borderColor: client.color,
                          animation:
                            hoveredIndex === index
                              ? 'ping 1.5s ease-out infinite'
                              : 'none'
                        }}
                      /> */}
                    </motion.div>
                    <Box sx={styles.clientInfo}>
                      <Typography sx={styles.clientName}>
                        {client.name}
                      </Typography>
                      {/* <Typography sx={styles.clientCategory}>
                        {client.category}
                      </Typography> */}
                    </Box>
                    <Box sx={styles.cornerTopLeft} />
                    <Box sx={styles.cornerBottomRight} />
                  </Box>
                  <Box
                    sx={{
                      ...styles.shimmer,
                      opacity: hoveredIndex === index ? 1 : 0
                    }}
                  />
                </Box>
              </motion.div>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
};

export default OurProjectsLogo;
